import { Events } from "../../events";

export function ReportError(errorHtml: string) {
  // Events.dispatch(Events.TOAST, errorHtml)
  alert(errorHtml)
}